import { render, staticRenderFns } from "./list-posts.vue?vue&type=template&id=e1655fdc&lang=pug&"
import script from "./list-posts.vue?vue&type=script&lang=js&"
export * from "./list-posts.vue?vue&type=script&lang=js&"
import style0 from "./list-posts.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports